import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchUpdates } from '../actions/updates'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import UpdateList from '../components/UpdateList'

import UpdatesFilterForm from '../forms/UpdatesFilterForm'

import '../styles/UpdatesView.css'

class UpdatesView extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10)
    this.props.fetchUpdates('', '', today, today)
  }

  renderUpdates() {
    const { updates, error, loading } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!updates || loading) {
      return <LoadingProgress />
    }

    return <UpdateList updates={updates} />
  }

  render() {
    const { updates, loading } = this.props
    const count = (!loading && updates) ? updates.length : null

    return (
      <div className="updates-view">

        {/* ── Header ── */}
        <div className="updates-header">
          <div className="updates-header-content">
            <div className="updates-header-text">
              <h1>
                <i className="fas fa-sync-alt"></i>
                <span className="text-vw-dark">Actualizaciones</span>
              </h1>
              <p className="updates-subtitle">Registro de actualizaciones de taquillas</p>
            </div>
            {count !== null && (
              <div className="updates-header-badge">
                <span className="updates-count-badge">{count} registros</span>
              </div>
            )}
          </div>
        </div>

        {/* ── Filter card ── */}
        <div className="updates-filter-card">
          <div className="updates-section-header">
            <i className="fas fa-filter"></i> Filtros
          </div>
          <div className="updates-section-body">
            <UpdatesFilterForm />
          </div>
        </div>

        {/* ── Results card ── */}
        <div className="updates-section-card">
          <div className="updates-section-header">
            <i className="fas fa-list"></i> Registros
          </div>
          <div className="updates-section-body p-0">
            {this.renderUpdates()}
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  updates: state.updates.updates,
  error: state.updates.error,
  loading: state.updates.loading,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchUpdates: bindActionCreators(fetchUpdates, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatesView)


